import type { QueryClient } from '@tanstack/react-query'

/**
 * Espelha uma preferência na SESSÃO em cache
 * (SPEC-20261006-2121-preferencia-que-volta).
 *
 * As preferências são LIDAS da sessão (`/auth/me`), carregada uma vez quando o
 * app abre e guardada em cache por minutos. Gravar só no servidor deixava essa
 * cópia velha: sair da tela e voltar SEM recarregar a página remontava o
 * componente, que lia a cópia velha — e o filtro, a coluna ou a largura
 * escolhida "sumia", até um F5. Atualizar a cópia junto com a gravação faz a
 * volta encontrar a última escolha.
 *
 * Mora fora de `layout-prefs.ts` porque aquele importa o cliente da API, que
 * exige o navegador — e esta regra tem de ser testável sem ele.
 */
export function espelharNaSessao(queryClient: QueryClient, chave: string, valor: unknown) {
  // TODAS as sessões em cache: a chave leva o token desde 2026-10-08
  // (['session', token]) — escrever só em ['session'] deixava a cópia lida
  // pela tela velha, e a escolha "sumia" de novo até um F5
  queryClient.setQueriesData({ queryKey: ['session'] }, (antes: unknown) => {
    if (!antes || typeof antes !== 'object') return antes
    const sessao = antes as { user?: { layoutPrefs?: unknown } }
    if (!sessao.user) return antes
    return {
      ...sessao,
      user: {
        ...sessao.user,
        layoutPrefs: { ...((sessao.user.layoutPrefs as Record<string, unknown>) ?? {}), [chave]: valor },
      },
    }
  })
}
